import { render, staticRenderFns } from "./ActivityResourcesForm.vue?vue&type=template&id=09aba392&scoped=true&"
import script from "./ActivityResourcesForm.vue?vue&type=script&lang=js&"
export * from "./ActivityResourcesForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivityResourcesForm.vue?vue&type=style&index=0&id=09aba392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aba392",
  null
  
)

export default component.exports